<template>
  <div class="iosbuy">
    <p class="title">配套知识 - 假期后作息调整</p>
    <div class="block">
      <p class="common-p">
        休了一个假期，你有没有感到轻松一些？
      </p>
      <p class="common-p">
        假期可以帮助我们放松身体，恢复能量。可是，假期结束后，我们往往很难立即调整过来：已经深夜，你还是觉得大脑兴奋，一点也不困；已经到工作或学习的时间，你却还是感觉昏昏沉沉。
      </p>
      <p class="common-p">
      这可能并非是由于你的假期不够放松，而可能是放假时，我们可以不被束缚，放开娱乐或纵情于自己感兴趣的事情，导致作息有些被打乱，这个练习，专为帮助你调节假期后的状态，更快地进入正常的作息节奏，需要入睡的时刻能入睡，需要起床的时刻精神好。
      </p>
      <p class="common-p">
      本次练习分为两个部分：
      </p>
      <p class="common-p">
        第一部分为<b>助眠部分</b>，供夜间准备入睡的时候使用，帮助降低神经的兴奋性，从而达到助眠的作用。练习过程中，睡着了就顺其自然，安心入睡即可，你的潜意识会持续发挥作用，在你睡着之后继续帮助你进行调节。如果练习完成后，你还没有入睡，该练习也会帮助你的身体和大脑得到一定的放松、休息，减少睡眠不足对你产生的影响。建议连续睡前使用至少三天以上，帮助大脑养成科学入睡的习惯，从而自然地回到健康的作息状态，
      </p>
      <p class="common-p">
      第二部分为<b>晨起调节部分</b>，供日间起床时使用，帮助唤醒心中的动力，从而达到激活精力的作用。
      </p>
      <p class="common-p">
      只是夜间到点不困，可以只练习第一部分；只是日间感觉头脑反应慢或者无精神，可以只是练习第二部分；也可都练习。作息严重打乱者两部分都练习的同时，要注意循序渐进地调整，例如假期是凌晨3点睡，那么建议第一晚调节作息的设置为凌晨1点-2点去睡，同时要辅助白天适度的运动以促进夜晚的睡眠，第二晚再将睡眠时间提前为12点半左右，以此类推，也可以辅助【小睡眠APP】内的相关午休练习。
      </p>
      <p class="common-p">
      第一次练习你可能觉得有些难进入状态，无需担心，这是正常的，你只需要放松地重复听这个练习，你的潜意识会一直帮助着你，进行着无意识地学习，因此练习得越多，你会发现你的作息自然地就调节过来了。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'android-buy',
  mounted () {
    document.title = '配套知识 - 假期后作息调整\n'
  }
}
</script>

<style lang="scss" scoped>
.iosbuy {
  color: #000!important;
  font-size: px2html(14px);
  box-sizing: border-box;
  margin-top: px2html(20px);
  padding-left: px2html(21px);
  padding-right: px2html(21px);
  text-align: justify;
  .title {
    text-align: left;
    font-size: 16px;
    font-weight: 900;
    margin-bottom: 28px;
  }
  .block {
    margin-bottom: px2html(28px);
  }
  .two-title {
    font-weight: 700;
    text-align: left;
    margin-bottom: px2html(14px);
  }
  .common-p {
    text-align: justify;
    margin-bottom: 17px;
  }
}
</style>
